export default __webpack_public_path__ + "static/1631-f946979f0d42fb90d65a602297818fb9.gif";